import React from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { WhatIncludes } from '../components/WhatIncludes';
import { Benefits } from '../components/Benefits';
import { Offer } from '../components/Offer';
import { Testimonials } from '../components/Testimonials';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function LandingPage() {
  // Initialize Meta Pixel on page load
  useMetaPixel();
  return <div className="w-full min-h-screen bg-white" data-id="element-302">
      <Navigation data-id="element-303" />
      <Hero data-id="element-304" />
      <WhatIncludes data-id="element-305" />
      <Benefits data-id="element-306" />
      <Offer data-id="element-307" />
      <Testimonials data-id="element-308" />
      <FinalCTA data-id="element-309" />
      <Footer data-id="element-310" />
    </div>;
}